import { render, staticRenderFns } from "./jurisdiction.vue?vue&type=template&id=6f42355d&scoped=true&"
import script from "./jurisdiction.vue?vue&type=script&lang=js&"
export * from "./jurisdiction.vue?vue&type=script&lang=js&"
import style0 from "./jurisdiction.vue?vue&type=style&index=0&id=6f42355d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f42355d",
  null
  
)

export default component.exports